var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div kendo-window=\"main.ls.logoutWin\" k-visible=\"false\" k-modal=\"true\" k-title=\"'Uscita'\">\n<p>\nVisulizzi questo messaggio perchè la sessione è scaduta oppure perchè risulti inattivo da troppo tempo.\n</p>\n<p>\nRieffettua il login per procedere.\n</p>\n<hr>\n<a class=\"pull-right k-button\" ng-click=\"main.ls.logoutWin.close()\" ui-sref=\"login\">Login</a>\n</div>\n";
var id1="logoutWin.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;